<template>
  <span class="date-value text-no-wrap">{{ dateValue }}</span>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'DateValue',
  props: {
    value: {
      type: String,
      description: 'ISO string in UTC'
    },
    zone: {
      type: String,
      description: 'time zone to convert to for display. Default is undefined which should make it "local" browser time'
    }
  },
  computed: {
    dateValue() {
      if (this.value === null || this.value === undefined) {
        return null
      }

      let dateTime = DateTime.fromISO(this.value, { zone: this.zone })
      if (dateTime.isValid) {
        return dateTime.toFormat('yyyy-MM-dd')
      }
      return this.value
    }
  }
}
</script>
